import api from './api';

// ─── Field Mapping Helpers ────────────────────────────────────────────────────

/**
 * Normalize a single API career-application object → app-friendly shape.
 */
const normalize = (item) => ({
  id:          item.id,
  careerId:    item.career_id    ?? item.careerId    ?? null,
  careerTitle: item.career_title ?? item.careerTitle ?? item.job_title ?? '',
  fullName:    item.full_name    ?? item.fullName    ?? '',
  email:       item.email        ?? '',
  phone:       item.phone        ?? '',
  coverLetter: item.cover_letter ?? item.coverLetter ?? '',
  resumeUrl:   item.resume       ?? item.resume_url  ?? item.resumeUrl ?? null,
  status:      item.status       ?? 'pending',
  appliedAt:   item.created_at   ?? item.appliedAt   ?? null,
  updatedAt:   item.updated_at   ?? item.updatedAt   ?? null,
});

// ─── Career Application Service ───────────────────────────────────────────────

export const careerApplicationService = {
  /**
   * GET /career-applications
   * Returns paginated list of all applications.
   */
  getAll: async (params = {}) => {
    const response = await api.get('/career-applications', { params });
    const raw = response.data;

    const list  = Array.isArray(raw)       ? raw
                : Array.isArray(raw.data)  ? raw.data
                : [];
    const total = raw.total ?? list.length;

    return {
      data: {
        applications: list.map(normalize),
        total,
        page:         raw.page       ?? (params.page  || 1),
        totalPages:   raw.totalPages ?? Math.ceil(total / (params.limit || 10)),
      },
    };
  },

  /**
   * GET /career-applications/:id
   * Returns a single application.
   */
  getById: async (id) => {
    const response = await api.get(`/career-applications/${id}`);
    const raw = response.data?.data ?? response.data;
    return { data: normalize(raw) };
  },

  /**
   * PATCH /career-applications/status/:id
   * Updates the status of an application.
   * @param {string|number} id
   * @param {string} status  - 'pending' | 'shortlisted' | 'rejected' | 'hired'
   */
  updateStatus: async (id, status) => {
    const response = await api.patch(`/career-applications/status/${id}`, { status });
    return response;
  },

  /**
   * DELETE /career-applications/:id
   */
  delete: async (id) => {
    return api.delete(`/career-applications/${id}`);
  },
};
